import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(24),
  position: "sticky",
  gap: 10,
  width: "100%",
  backgroundColor: theme.palette.white,
  borderRadius: "10px",
  border: `1px solid ${theme.palette.fly.brandBorder}`,
}));

export const Header = styled("div")(({ theme }) => ({
  padding: "20px 10px",
  borderBottom: `1px solid ${theme.palette.border.light}`,
}));

export const Title = styled("h4")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "600",
  color: theme.palette.text.primary,
}));

export const PriceItem = styled("div")(({ theme, $isSmallText }) => ({
  ...theme.mixins.flexCenterBetween,
  fontSize: $isSmallText ? 14 : 18,
  color: "#4a4a4a",

  "& > span.commission": {
    color: "#dc2626",
  },

  "& > .price__footer": {
    fontSize: "15px",
    fontWeight: "600",
    color: theme.palette.text.primary,
  },

  "& > .total__amount": {
    fontSize: "24px",
    fontWeight: "700",
    color: theme.palette.primary.main,
    letterSpacing: "-0.5px",
  },

  [theme.down("md")]: {
    "& > .total__amount": {
      fontSize: "22px",
    },
  },

  [theme.down("sm")]: {
    fontSize: $isSmallText ? 12 : 15,

    "& > .price__footer": {
      fontSize: "14px",
    },

    "& > .total__amount": {
      fontSize: "18px",
    },
  },

  [theme.down("xs")]: {
    fontSize: $isSmallText ? 11 : 13,

    "& > .price__footer": {
      fontSize: "13px",
    },

    "& > .total__amount": {
      fontSize: "16px",
    },
  },
}));

export const LineDivider = styled("div")(({ theme }) => ({
  width: "100%",
  height: 1,
  backgroundColor: theme.palette.border.darker,
}));
